<template>
    <div class="card card_product">
        <div class="product_wrap">
            <a :href="detailUrl" v-on:click.prevent="onPdpClick" class="image_part lazy" :aria-label="titleText">
                <img :src="thumbnailUrl" :data-static="thumbnailStaticUrl" :alt="titleWithBrand"
                    onerror="this.src=this.dataset.static"/>
            </a>
            <div class="content_part">
                <div class="brand_sku">
                    <div class="product_brand" v-if="brand" v-html="brand"></div>
                    <div class="product_sku" v-if="isUsedEquipment"><strong>SKU:&nbsp;</strong>{{productSku}}</div>
                </div>
                <div class="product_title" v-if="titleText">
                    <a :href="detailUrl" v-on:click.prevent="onPdpClick">{{titleText}}</a>
                </div>
                <ul class="product_specs" v-if="bulletOne || bulletTwo || bulletThree">
                    <li v-if="bulletOne" v-html="bulletOne"></li>
                    <li v-if="bulletTwo" v-html="bulletTwo"></li>
                    <li v-if="bulletThree" v-html="bulletThree"></li>
                </ul>

                <button class="styled_button yellow product_raq_button" v-on:click.prevent="requestAQuote" v-if="!primaryCta.isAddToCart && ctaUrl">Request a Quote</button>

                <div class="product_controls" v-if="!loading">
                    <add-to-cart v-if="primaryCta.isAddToCart && addToCartOptions.labels != null"
                                 :product="addProductData"
                                 :options='addToCartOptions'
                                 :image-url="thumbnailUrl"
                                 :button-disabled="addButtonDisabled"
                                 :product-pricing="productPricing"
                                 v-on:addedtocart="$emit('addedtocart')"></add-to-cart>
                </div>

                <div class="product_price" :class='{is_used_equipment: isUsedEquipment, no_price_displayed: !productPriceShown, has_price_displayed: productPriceShown}'>
                    <pricing-info v-if="productPriceShown" :is-new-equipment="isNewEquipment" :loading="priceLoading" :show="showPrice" :price-object="productPricing" :show-old="!isNewEquipment" :no-cents="!showCents"></pricing-info>
                    <pricing-info v-else-if="isUsedEquipment"></pricing-info>
                </div>

                <button class="styled_button colourless product_view_details_button" v-on:click.prevent="onPdpClick">View Details</button>

                <div class="price_help" v-if="promoText">{{ promoText }}</div>
            </div>
        </div>
    </div>
</template>
<script>
    import PricingInfo from "./../PricingInfo";
    import { Constants } from "../../functions/constants";
    import cardMixin from "../../mixins/card-mixin";
    import AddToCart from "../AddToCart";
    import { store, mutations } from "../../stores/picked-products-store";

    export default {
        name: "Product",
        mixins: [cardMixin],
        components: { AddToCart, PricingInfo },
        data() {
            return {
                showPromo: false,
                isSelected: false,
                isSubscribed: false,
                isBusinessCustomer: false,
                isLoggedIn: false,
                addButtonDisabled: false,
            }
        },
        props: {
            model: {
                type: Object,
                default: {}
            },
            addToCartOptions: {
                type: Object,
                default: {}
            }
        },
        methods: {
            selectForCompare: function selectForCompare() {
                if (this.isSelected) {
                    if (!this.isSubscribed) {
                        GlobalApp.EventHub.subscribeToEvent(Constants.EVENTS.COMPARE_PRODUCTS_REMOVED, this.productsRemoveEvent);
                        this.isSubscribed = true;
                    }

                    mutations.pickProduct(this.customDict.unique_id, this.titleText, this.thumbnailUrl, this.detailUrl);
                } else {
                    mutations.unpickProduct(this.customDict.unique_id);
                }
            },
            productsRemoveEvent: function () {
                if (!this.isSelected)
                    return;

                let indexOfProduct = this.pickedProducts.findIndex(p => (p && p.id === this.customDict.unique_id));
                if (indexOfProduct === -1)
                    this.isSelected = false;
            },
            onPdpClick: function (e) {
                this.$emit('clicked', e);
           },
            onCompareClick: function (e) {
                var checkbox = this.$refs.compareInput;
                if (!checkbox.disabled) {
                    this.isSelected = !this.isSelected;
                }
                this.selectForCompare();
            },
            requestAQuote: function (e) {
                this.$emit('converted', e);
                window.open(this.ctaUrl);
            }
        },
        computed: {
            pickedProducts: function () {
                return store.products;
            },
            isSelectionDisabled: function () {
                return this.isSelected === false && store.usedSlots >= Constants.PRODUCTS_COMPARE.NUMBER_OF_SLOTS;
            },
            bulletOne: function () {
                return this.customDict[Constants.ALGOLIA.PRODUCT.BULLET1];
            },
            bulletTwo: function () {
                return this.customDict[Constants.ALGOLIA.PRODUCT.BULLET2];
            },
            bulletThree: function () {
                return this.customDict[Constants.ALGOLIA.PRODUCT.BULLET3];
            },
            ctaUrl: function () {
                let url = '';

                if (this.customDict["cta_call_to_actionecommerce"] === "Call to Action|Request a Quote" || this.customDict["cta_call_to_actionecommerce"] === Constants.ALGOLIA.PRODUCT.CTA.VALUE_REQUEST_QUOTE) {
                    url = `/equipment/${this.customDict["item_condition"].toLowerCase()}/request-a-quote?pid=${this.entityId}`
                }

                return url;
            },
            promoText: function () {
                let promoText = this.customDict[Constants.ALGOLIA.PRODUCT.PROMOTION_TEXT];

                if (typeof promoText === 'string')
                    return promoText;

                if (typeof promoText === 'object' && promoText.length > 0) {
                    return promoText[0];
                }

                return false;
            },
            showPrice: function () {
                return this.shouldShowPrice(this.isBusinessCustomer);
            },
            showCents: function () {
                return this.productDetails?.isPart();
            },
            priceLoading: function () {
                if (!this.model)
                    return false;

                if (this.model.IsPriceReloading === true)
                    return true;

                return false;
            },
            isNewEquipment: function () {
                return this.productDetails?.isNewEquipment();
            },
            isUsedEquipment: function () {
                return this.productDetails?.isUsedEquipment();
            },
            productPriceShown: function() {
                return this.showPrice && this.productPricing && (this.productPricing.main >= 1 || this.productPricing.crossed);
            },
            titleWithBrand: function () {
                return this.brand && this.isNewEquipment ? this.brand + ' ' + this.titleText : this.titleText;
            }
        },
        async created() {
            let customerData = await GlobalApp.CustomerService.getCurrentCustomer();
            this.isLoggedIn = customerData != null && customerData?.BigCommerceDetails?.Id > 0;
            this.isBusinessCustomer = customerData?.BigCommerceDetails?.AccountType === Constants.CUSTOMER.ACCOUNT_TYPE.BUSINESS;
        },
        destroyed() {
            GlobalApp.EventHub.unsubscribeToEvent(Constants.EVENTS.COMPARE_PRODUCTS_REMOVED, this.productsRemoveEvent);
        }
    };
</script>